import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core'

import { SourcesBase } from './Sources'

import { routeActions } from 'reduxModules/actions/RouteActions'
import { snackbarActions } from 'reduxModules/actions/SnackbarActions'
import { isLoadingSelector, bookingsWithoutBlacklistSelector } from 'reduxModules/selectors/BookingSelectors'
import {
  sheetBookingsSelector,
  sheetLimitSelector,
  bookedSelector,
  mergedSourcesSelector,
  totalLimitSelector
} from 'reduxModules/selectors/SourceSelectors'
import { isDisabledSelector, routeIdSelector, routeCompanySelector } from 'reduxModules/selectors/RouteSelectors'
import { companySelector, isUserWithFullAccessSelector } from 'reduxModules/selectors/UserSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  isDisabled: isDisabledSelector,
  routeId: routeIdSelector,
  routeCompany: routeCompanySelector,
  company: companySelector,
  isLoading: isLoadingSelector,
  bookingsWithoutBlacklist: bookingsWithoutBlacklistSelector,
  sheetBookings: sheetBookingsSelector,
  sheetLimit: sheetLimitSelector,
  booked: bookedSelector,
  mergedSources: mergedSourcesSelector,
  totalLimit: totalLimitSelector,
  isUserWithFullAccess: isUserWithFullAccessSelector
})

const mapDispatchToProps = {
  showSnackbar: snackbarActions.showSnackbar,
  changeSourceData: routeActions.changeSourceData,
  setSourceData: routeActions.setSourceData,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const Sources = enhance(SourcesBase)


// WEBPACK FOOTER //
// ./src/components/Sources/index.js